import React from 'react';
import { List } from 'immutable';

import {
  Paragraph,
  View,
  CoreLink,
} from '@uncinc/react-drupal-core';

import {
  Container,
  WysiwygField,
  Image,
} from '@uncinc/uncinc-react-kitchen-sink';


import './style.scss';
import { PAGES_MORE_NEWS_URL } from '../../../../config/constants';

const NodeArticleDetail = ({ entity, className }) => {
  const title = entity.getIn(['title', 0, 'value']);
  const body = entity.getIn(['body', 0, 'processed'], '');
  const imgSrc = entity.getIn(['field_image', 0, 'source']);
  const imgAlt = entity.getIn(['field_image', 0, 'title']);
  const articleDate = new Date(
    entity.getIn(['created', 0, 'value'])).toLocaleDateString(
    'nl-NL',
    {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    },
  );
  const articleType = entity.getIn(['field_article_type', 0, 'entity', 'name', 0, 'value']);
  const subjects = entity.get('field_subject', List());

  const nid = entity.getIn(['nid', 0, 'value']);
  const articleTypeId = entity.getIn(['field_article_type', 0, 'target_id']);


  return (
    <article className="NodeArticleDetail">
      <Container>
        <div className="NodeArticleDetail__hero row">
          <div className="col-12 col-md-5 NodeArticleDetail__image__wrapper">
            {imgSrc && imgAlt && (
              <Image
                className="NodeArticleDetail__image"
                lazyload={false}
                src={imgSrc}
                alt={imgAlt}
              />
            )}
          </div>

          <div className="col-12 col-md-7 NodeArticleDetail__text__wrapper">
            <div className="NodeArticleDetail__text">
              <h1 className="NodeArticleDetail__title">{title}</h1>
              <WysiwygField
                className="NodeArticleDetail__body"
                property="schema:text"
                html={body}
              />

              <div className="NodeArticleDetail__info">
                <div className="NodeArticleDetail__tags">
                  {subjects.map((subject) => {
                    const id = subject.get('target_id');
                    const searchUrl = `${PAGES_MORE_NEWS_URL}?field_subject_target_id=${id}`;
                    return (
                      <CoreLink to={searchUrl} className="NodeArticleDetail__tags__tag" key={id}>
                        {subject.getIn(['entity', 'name', 0, 'value'])}
                      </CoreLink>
                    );
                  })}
                </div>

                <div className="NodeArticleDetail__date">
                  <div className="NodeArticleDetail__date__type">
                    {articleType}
                  </div>

                  <div className="NodeArticleDetail__date__date">
                    {articleDate}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Container>

      {/* Start of paragraphs */}
      {entity.get('field_paragraphs') ? (
        <div className="node--page--paragraphs-wrapper">
          {entity.get('field_paragraphs', List()).map((paragraph) => {
            const id = paragraph.get('target_id');
            const language = paragraph.getIn(['entity', 'langcode', 0, 'value']);
            return (
              <div key={`paragraph:${id}:${language}`} id={id} className="ParagraphAnchorWrapper">
                <Paragraph
                  key={`paragraph:${id}`}
                  id={id}
                  entity={paragraph.get('entity')}
                />
              </div>
            );
          })}
        </div>
      ) : null}
      {/* End of paragraphs */}

      <Container className="NodeArticleDetail__recent__articles">
        <div className="row">
          <div className="col-12">
            <View id="recent_articles" display="block_1" args={[articleTypeId, nid]} />
          </div>
        </div>
      </Container>

    </article>
  );
};

export default NodeArticleDetail;
